import { CommonDateRange, CrossButton, CustomPagination, CustomSelect } from 'components'
import React, { useContext, useEffect, useMemo, useState } from 'react';
import moment from "moment";
import './invoiceLrToLrPayment.css'
import { IoCheckbox, IoSquareOutline } from 'react-icons/io5';
import { StorageServices } from 'utils';
import { supplierTripListApi } from '_services/accountsServices/supplierServices';
import { UserContext } from 'context';
import SingleSelectDropdownInfinite from 'components/common/SingleSelectDropdownInfinite/SingleSelectDropdownInfinite';
import { getAllVehicleNumber, handleKeyDown } from '_services';
import { addPaymentLrToLrInvoiceDetails, createPaymentInvoiceDetails } from '_services/invoiceBillRaiseServices';

const getLedgerTotalAmount = (data, key) => {
    try {
        if (!Array.isArray(data)) return 0;
        
        const total = data.reduce((sum, item) => {
            const value = item?.lr_freight?.[key];
            // Convert string to number if needed, otherwise use the value
            const numericValue = typeof value === 'string' ? parseFloat(value) || 0 : value || 0;
            return sum + numericValue;
        }, 0);
        
        // Return with 2 decimal places
        return parseFloat(total.toFixed(2));
    } catch (error) {
        return 0;
    }
}

const InvoiceLrToLrPayment = (props) => {
    let { isOpen, onClose, previousModal, callInvoiceDetailsApi } = props;
    const [isLoading, setIsLoading] = useState(false)
    const [supplierLrList, setSupplierLrList] = useState([])

    const supplierTripPayHandle = async (data) => {
        const payload = {
            company_id: isOpen?.company_id,
            billraise_id: isOpen?.billraise_id,
            amount: +isOpen?.amount, // parseInt(isOpen?.amount),
        }

        try {
            setIsLoading(true)

            const res = await addPaymentLrToLrInvoiceDetails(payload)
            if (res?.responseCode == 200) {
                setSupplierLrList(res?.data)
                // setTotalItems(res?.data?.total_record)
            }
        } catch (error) {

        } finally {
            setIsLoading(false)
        }
    }

    useEffect(() => {
        if (isOpen) {
            supplierTripPayHandle()
        }
    }, [isOpen])

    const onCloseHandler = () => {
        onClose(false);
        previousModal(isOpen);
    }

    const listLrForApi = useMemo(() => {
        return supplierLrList?.lr_list?.filter((el) => Number(el?.is_checked) === 1 && Number(el?.lr_freight?.distributed > 0))?.map((item) => {
            return {
                lr_id: item?._id,
                lr_number: item?.lr_number,
                trip_id: item?.trip_id?._id,
                trip_number: item?.trip_id?.trip_number,
                amount: item?.lr_freight?.distributed,
            }
        })
    }, [supplierLrList])

    const onSubmitExpense = async () => {
        setIsLoading(true);
        try {
            const payload = {
                ...isOpen,
                // amount: parseInt(isOpen?.amount),
                lrs: listLrForApi,
            };
            const res = await createPaymentInvoiceDetails(payload);
            if (res?.responseCode === 200) {
                setIsLoading(false);
                onClose(false);
                callInvoiceDetailsApi();
            } else {
                setIsLoading(false);
            }
        } catch {
            setIsLoading(false);
        }
    };

    const handleTdsPercentageChange = (lrId, value, totalAmount, currentLrAmount) => {
        // Allow digits and decimal point only
        const numValue = value.replace(/[^0-9.]/g, '');

        // Prevent multiple decimal points
        const decimalCount = (numValue.match(/\./g) || []).length;
        if (decimalCount > 1) {
            return;
        }

        // Allow empty string
        if (numValue === '') {
            updateLrTdsData(lrId, '');
            return;
        }

        // Parse as float to handle decimal values
        const tdsAmount = parseFloat(numValue);

        // Validate the amount
        if (!isNaN(tdsAmount) && tdsAmount <= currentLrAmount && tdsAmount <= totalAmount) {
            updateLrTdsData(lrId, numValue); // Pass the string to preserve decimal format
        } else if (numValue.endsWith('.')) {
            // Allow typing decimal point
            updateLrTdsData(lrId, numValue);
        }
    }

    const updateLrTdsData = (lrId, tdsAmount) => {
        setSupplierLrList(prevState => {
            const updatedLrList = prevState?.lr_list?.map(lr => {
                if (lr._id === lrId) {
                    // Keep the string value for distributed to preserve decimal input
                    const numericAmount = tdsAmount === '' ? 0 : parseFloat(tdsAmount) || 0;

                    return {
                        ...lr,
                        is_checked: numericAmount > 0 ? true : false,
                        payment_status: numericAmount > 0
                            ? (lr?.lr_freight?.balance === numericAmount ? 'Full Payment' : 'Partial Payment')
                            : 'No Payment',
                        lr_freight: {
                            ...lr.lr_freight,
                            distributed: tdsAmount, // Store as string to preserve decimal point
                        }
                    };
                }
                return lr;
            });

            // Recalculate total TDS amount
            const totalTdsAmount = updatedLrList.reduce((sum, lr) => {
                return sum + (lr.is_checked ? (lr.lr_freight.total_tds || 0) : 0);
            }, 0);

            return {
                ...prevState,
                lr_list: updatedLrList,
                total_tds_amount: totalTdsAmount
            };
        });
    }

    return (
        <>
            <div className="offcanvas-header">
                <h5 className="offcanvas-title"> Select LR for Payment </h5>
                <CrossButton type="button" className="_switchBtn  __animEffect_btn" style={{ marginLeft: 'auto' }} onClick={(e) => onCloseHandler(e)}>
                    <svg className="cross" xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
                        <path
                            d="M12.5321 0.477671C12.4422 0.387555 12.3353 0.316061 12.2177 0.267281C12.1001 0.2185 11.9741 0.193391 11.8468 0.193391C11.7195 0.193391 11.5934 0.2185 11.4758 0.267281C11.3582 0.316061 11.2514 0.387555 11.1615 0.477671L6.40798 5.22143L1.6545 0.46795C1.56451 0.377952 1.45766 0.306563 1.34008 0.257857C1.22249 0.20915 1.09646 0.184082 0.969185 0.184082C0.84191 0.184082 0.715881 0.20915 0.598294 0.257857C0.480707 0.306563 0.373865 0.377952 0.283868 0.46795C0.19387 0.557947 0.122481 0.664789 0.0737746 0.782376C0.0250685 0.899963 -9.48274e-10 1.02599 0 1.15327C9.48275e-10 1.28054 0.0250684 1.40657 0.0737746 1.52416C0.122481 1.64175 0.19387 1.74859 0.283868 1.83858L5.03735 6.59206L0.283868 11.3455C0.19387 11.4355 0.122481 11.5424 0.0737746 11.66C0.0250685 11.7776 0 11.9036 0 12.0309C0 12.1581 0.0250685 12.2842 0.0737746 12.4017C0.122481 12.5193 0.19387 12.6262 0.283868 12.7162C0.373865 12.8062 0.480707 12.8776 0.598294 12.9263C0.715881 12.975 0.84191 13 0.969185 13C1.09646 13 1.22249 12.975 1.34008 12.9263C1.45766 12.8776 1.56451 12.8062 1.6545 12.7162L6.40798 7.9627L11.1615 12.7162C11.2515 12.8062 11.3583 12.8776 11.4759 12.9263C11.5935 12.975 11.7195 13 11.8468 13C11.974 13 12.1001 12.975 12.2177 12.9263C12.3353 12.8776 12.4421 12.8062 12.5321 12.7162C12.6221 12.6262 12.6935 12.5193 12.7422 12.4017C12.7909 12.2842 12.816 12.1581 12.816 12.0309C12.816 11.9036 12.7909 11.7776 12.7422 11.66C12.6935 11.5424 12.6221 11.4355 12.5321 11.3455L7.77861 6.59206L12.5321 1.83858C12.9015 1.46919 12.9015 0.847062 12.5321 0.477671Z"
                            fill="black" />
                    </svg>
                </CrossButton>
            </div>

            <div className="offcanvas-body">
                <div className='__supsAdd_bg'>
                    <div className='__addPayTable_bx'>
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '2%' }}><div></div></th>
                                    <th><div>LR Date</div></th>
                                    <th><div>LR Number</div></th>
                                    <th><div>Trip Number</div></th>
                                    <th><div>Invoice number</div></th>
                                    <th style={{ width: '9%' }}><div>From Station</div></th>
                                    <th style={{ width: '15%' }}><div>To Station</div></th>
                                    <th><div>Receipt</div></th>
                                    <th>Balance Due</th>
                                </tr>
                            </thead>

                            {supplierLrList?.lr_list?.length > 0 ?
                                supplierLrList?.lr_list?.map((itemLr) => {
                                    return (
                                        <tbody className='__pdTd_bxs' key={itemLr._id}>
                                            <tr
                                                className={`__paySclIn_bx ${itemLr?.payment_status === 'Full Payment' ? '__fulPay_bxs' :
                                                    itemLr?.payment_status === 'Partial Payment' ? '__partialPay_bxs' :
                                                        '__totalPay_bxs'
                                                    }`}
                                            >
                                                <td>
                                                    <div
                                                        className={itemLr?.is_checked ? '__chkPYap' : '__disable_chkPYap'}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        {itemLr?.is_checked ? <IoCheckbox /> : <IoSquareOutline />}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>
                                                        {moment(itemLr?.dispatch_date).format('DD/M/YYYY') || ""}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className=''>
                                                        {itemLr?.lr_number || '-'}
                                                    </div>
                                                </td>
                                                <td>
                                                    <div>{itemLr?.trip_id?.trip_number || '-'}</div>
                                                </td>
                                                <td>
                                                    <div>{itemLr?.invoice_number || '-'}</div>
                                                </td>
                                                <td>
                                                    <div className='_locationWid_bx'>
                                                        <p className="_tblText">{itemLr?.from_location}</p>
                                                        <p className="_lgtText"> {itemLr?.unit_id?.name} </p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='_locationWid_bx'>
                                                        <p className="_tblText">{itemLr?.to_location}</p>
                                                        <p className="_lgtText"> {itemLr?.consignee_id?.name} </p>
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='__sPay_input'>
                                                        <input
                                                            type="text"
                                                            value={itemLr?.lr_freight?.distributed || ''}
                                                            onChange={(e) => handleTdsPercentageChange(itemLr._id, e.target.value, supplierLrList?.total_distributed_amount, itemLr?.lr_freight?.balance)}
                                                            placeholder="Amount (₹)"
                                                            maxLength={12}
                                                            onKeyDown={handleKeyDown}
                                                        />
                                                    </div>
                                                </td>
                                                <td>
                                                    <div className='__mainPaid_bxs'>
                                                        <div> / ₹ {itemLr?.lr_freight?.balance?.toFixed(2) || '0.00'}</div>
                                                        {itemLr?.payment_status === 'Full Payment' && (
                                                            <div className='__trpDeliver_stats'>Full Payment</div>
                                                        )}
                                                        {itemLr?.payment_status === 'Partial Payment' && (
                                                            <div className='__pod_stats'>Partial Payment</div>
                                                        )}
                                                        {itemLr?.payment_status === 'No Payment' && (
                                                            <div className='__no_pay_pod_stats'>No Payment</div>
                                                        )}
                                                    </div>
                                                </td>
                                            </tr>
                                        </tbody>
                                    );
                                })
                                :
                                <tbody className='__pdTd_bxs'>
                                    <tr className={`__paySclIn_bx __partialPay_bxs`}>
                                        <td>
                                            Loading...
                                        </td>
                                    </tr>
                                </tbody>
                            }
                        </table>
                    </div>

                    {/* {supplierLrList?.length > 0 && <div className="paginationFt_avt " style={{ borderBottom: 'none' }}>
                        <CustomPagination
                            totalItems={totalItems}
                            itemsPerPage={itemsPerPage}
                            currentPage={filter.offset}
                            onPageChange={handlePageChange}
                        />
                    </div>} */}
                </div>
            </div>

            <div className='offcanvas-footer' style={{ display: 'flex', justifyContent: "space-between" }}>
                <div style={{ display: 'flex', gap: "10px" }}>
                    <button
                        className='_addComm_btn _sameResWid'
                        onClick={() => {
                            onSubmitExpense(supplierLrList?.lr_list)
                            // Yaha API call karein
                            // continueForPayment(selectedLrs, calculateTotalPayment())
                        }}
                        disabled={supplierLrList?.total_distributed_amount !== getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed') || supplierLrList?.total_remaining_amount > 0 || isLoading}
                        style={{
                            opacity: supplierLrList?.total_remaining_amount > 0 ? 1 : 1,
                            cursor: supplierLrList?.total_remaining_amount > 0 ? 'not-allowed' : 'pointer'
                        }}
                    >
                        {isLoading ? 'Loading...' : 'Add Payment'}
                    </button>
                    <button
                        className='_cancel_btn'
                        onClick={(e) => onCloseHandler(e)}
                    >
                        Cancel
                    </button>
                </div>
                {(getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed') > supplierLrList?.total_distributed_amount) ?
                    <>
                        <span className='bottomBgRedLine'>
                            Invalid Receipt Amount ₹ {getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed')}
                        </span>
                        <span className='bottomBgLine'>
                            Allocation amount is ₹ {supplierLrList?.total_distributed_amount}
                        </span>
                    </>
                    :
                    (
                        (getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed') <= supplierLrList?.total_distributed_amount || getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed') === 0) ?
                            <>
                                <span className='bottomBgLine'>
                                    {`₹ ${getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed') ? getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed') : 0} has been Allocated`}
                                </span>
                                {(supplierLrList?.total_distributed_amount - getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed')) > 0 ? <span className='bottomBgRedLine'>
                                    Remaining Allocation Amount is ₹ {(supplierLrList?.total_distributed_amount - getLedgerTotalAmount(supplierLrList?.lr_list, 'distributed'))?.toFixed(2)}
                                </span> : <></>}
                            </>
                            :
                            <></>
                    )
                }

                {supplierLrList?.total_remaining_amount > 0 ? <span className='bottomBgRedLine'>
                    Invalid Remaining amount {supplierLrList?.total_remaining_amount?.toFixed(2)}
                </span> : <></>}
            </div>
        </>
    )
}

export default InvoiceLrToLrPayment